import { Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { AsyncPipe, TitleCasePipe } from '@angular/common';
import {
  Component,
  ChangeDetectionStrategy,
  output,
  inject,
} from '@angular/core';
import { PopoverModule } from 'primeng/popover';
import { AvatarModule } from 'primeng/avatar';
import { SelectModule } from 'primeng/select';
import { StyleClassModule } from 'primeng/styleclass';

import { ShortNamePipe } from '@fitness-force/pipes/short-name';
import { ClientService } from '@fitness-force/api';
import { DrawerModule } from 'primeng/drawer';
import { TranslateModule } from '@ngx-translate/core';
// import { FactoryHttpLoader } from '@fitness-force/shared';
// import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'client-info',
  templateUrl: './client-info.component.html',
  styleUrls: ['./client-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    AvatarModule,
    SelectModule,
    StyleClassModule,
    ShortNamePipe,
    PopoverModule,
    DrawerModule,
    TranslateModule,
    AsyncPipe,
    TitleCasePipe,
  ],
})
export class ClientInfoComponent {
  private readonly router = inject(Router);
  private readonly clientService = inject(ClientService);

  columnData: Observable<any> = new BehaviorSubject([]);
  readonly onAction = output<{ action: string; columnData: any }>();

  gotoClient(data: any) {
    this.onAction.emit({ action: 'showProfile', columnData: data });
  }

  clientStatus(client: any): string {
    if (client?.status)
      return this.clientService.getClientStatusHtml(client.status.toString());
    else return '';
  }
}
